export default `
<svg
  aria-hidden="true"
  aria-label="reaction-thumbsdown-selected"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <g transform="translate(12 12) scale(1.2003) translate(-18 -17.98825)">
    <path
      d="M19.4944 23.8084C20.1713 23.673 20.6113 23.0143 20.4759 22.3374L20.4161 22.0406C20.2781 21.3455 20.0229 20.6842 19.6662 20.0828H23.4153C24.1052 20.0828 24.665 19.523 24.665 18.8331C24.665 18.3514 24.3916 17.9323 23.9907 17.724C24.2745 17.4949 24.4567 17.1434 24.4567 16.7503C24.4567 16.1411 24.0193 15.6334 23.4439 15.524C23.5585 15.334 23.6236 15.1127 23.6236 14.8757C23.6236 14.3212 23.2617 13.85 22.7618 13.6885C22.78 13.6026 22.7905 13.5115 22.7905 13.4178C22.7905 12.7278 22.2307 12.1681 21.5408 12.1681H19.0023C18.5077 12.1681 18.026 12.3139 17.6147 12.5873L16.6123 13.2564C15.9172 13.7198 15.5006 14.5008 15.5006 15.3366V16.3337V17.5834V18.2317C15.5006 18.9919 15.8469 19.7079 16.4379 20.1843L16.6305 20.3379C17.3205 20.8899 17.7917 21.6657 17.9635 22.5301L18.0234 22.8269C18.1588 23.5038 18.8175 23.9438 19.4944 23.8084ZM12.1681 21.3325H13.8344C14.2952 21.3325 14.6675 20.9602 14.6675 20.4993V14.6675C14.6675 14.2066 14.2952 13.8343 13.8344 13.8343H12.1681C11.7073 13.8343 11.335 14.2066 11.335 14.6675V20.4993C11.335 20.9602 11.7073 21.3325 12.1681 21.3325Z"
      fill="currentcolor"
    />
  </g>
</svg>
`;
